import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/upload/upload.png'


const _withScopeId = n => (_pushScopeId("data-v-52ce45a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block container-box" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("请务必上传真实的工作内容视频(1个或多个)，以便保司进行核保和存档。 ")
const _hoisted_3 = { class: "from" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "video-box" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "percentage-value" }
const _hoisted_8 = { class: "percentage-label" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 增加一个 ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, " 最多可以上传3个 ", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 上传工作视频 ", -1))
const _hoisted_17 = {
  key: 0,
  class: "name"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 1.请拍摄实际操作的近景工作视频（能看清工人的具体操作）")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 2.视频时间10-60S，视频大小不超过20M ")
const _hoisted_21 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  class: "name"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode("提交审核 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_head = _resolveComponent("page-head")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_head, { title: "添加被派遣单位" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_alert, {
        type: "warning",
        "show-icon": ""
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_autocomplete, {
          modelValue: _ctx.companyName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyName) = $event)),
          style: {"width":"400px"},
          debounce: 500,
          "fetch-suggestions": _ctx.queryCompany,
          class: "inline-input",
          "trigger-on-focus": false,
          placeholder: "请输入被派遣单位全名"
        }, null, 8, ["modelValue", "fetch-suggestions"]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createVNode(_component_el_image, {
                fit: "cover",
                class: "video-cover",
                src: item.preview
              }, null, 8, ["src"]),
              _createElementVNode("i", {
                class: "delete el-icon el-icon-circle-close",
                onClick: ($event: any) => (_ctx.fileRemove(index))
              }, null, 8, _hoisted_6)
            ]))
          }), 128)),
          _createVNode(_component_el_upload, {
            class: "upload",
            style: _normalizeStyle(_ctx.files.length > 0?'width:180px':''),
            drag: "",
            name: "iFile",
            headers: { 'Access-Token': _ctx.token },
            multiple: "",
            "show-file-list": false,
            accept: "video/*",
            "http-request": _ctx.fileUpload,
            "before-upload": _ctx.beforeVideo,
            onChange: _cache[1] || (_cache[1] = 
        () => {
        _ctx.uploading = !_ctx.uploading
        }
        )
          }, {
            default: _withCtx(() => [
              (_ctx.percentage)
                ? (_openBlock(), _createBlock(_component_el_progress, {
                    key: 0,
                    type: "dashboard",
                    percentage: _ctx.percentage,
                    status: _ctx.progressStatus
                  }, {
                    default: _withCtx((data) => [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(data.percentage) + "%", 1),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.progressStatus === 'success'
                    ? '保存中'
                    : '文件上传中'), 1)
                    ]),
                    _: 1
                  }, 8, ["percentage", "status"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    (_ctx.files.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
                      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _hoisted_16,
                          (_ctx.hasAppFeature('dispatchVideoTips'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_21))
                            : (_openBlock(), _createElementBlock("div", _hoisted_22, " 视频时间10s-60s，视频大小不超过20M "))
                        ]))
                  ]))
            ]),
            _: 1
          }, 8, ["style", "headers", "http-request", "before-upload"])
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"width":"256px","height":"40px"},
          disabled: !_ctx.companyName,
          onClick: _ctx.onDispatchAdd
        }, {
          default: _withCtx(() => [
            _hoisted_23
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ])
  ], 64))
}